// Client mirror of server/utils/monthlyModel.js — used for the live preview in
// the user edit modal (full calendar month, no vacation/absences).

export const WEEKS_PER_MONTH = 4.33;
export const TARGET_FACTOR = 0.9;
export const EMERGENCY_FACTOR = 1.1;
export const DEFAULT_SHIFT_HOURS = 8;

export function previewMonthly({ contracted, preferred, employmentType, minijobCap, avgLen }) {
  const len = avgLen > 0 ? avgLen : DEFAULT_SHIFT_HOURS;
  const c = Number(contracted) || 0;
  const p = Number(preferred) || 0;
  const isMinijob = employmentType === 'minijob';
  const cap = isMinijob ? Number(minijobCap) || 0 : null;

  if (c <= 0 && p <= 0) {
    return { noValues: true, minHours: 0, target: 0, emergencyMax: 0, capHours: cap, capShifts: cap != null ? Math.floor(cap / len) : null, contractExceedsPreference: false, derivedPreferred: false };
  }
  const prefWeekly = p > 0 ? p : c / len;
  const preferredMonth = prefWeekly * WEEKS_PER_MONTH;
  const minHours = c * WEEKS_PER_MONTH;
  let target = Math.round(preferredMonth * TARGET_FACTOR);
  const baseEmergency = Math.round(preferredMonth * EMERGENCY_FACTOR);
  const minShifts = Math.ceil(minHours / len - 1e-9);
  if (minShifts > target) target = minShifts;
  return {
    noValues: false,
    minHours,
    target,
    emergencyMax: Math.max(baseEmergency, target),
    capHours: cap,
    capShifts: cap != null ? Math.floor(cap / len) : null,
    contractExceedsPreference: minShifts > baseEmergency,
    derivedPreferred: p <= 0,
  };
}

// Mean length (hours) of active shift templates
export function avgTemplateHours(templates) {
  const active = (templates || []).filter((t) => t.is_active);
  if (!active.length) return DEFAULT_SHIFT_HOURS;
  const mins = active.map((t) => {
    const [sh, sm] = t.start_time.split(':').map(Number);
    const [eh, em] = t.end_time.split(':').map(Number);
    let d = eh * 60 + em - (sh * 60 + sm);
    if (d <= 0) d += 1440;
    return d;
  });
  return mins.reduce((a, b) => a + b, 0) / mins.length / 60;
}
